import { render, staticRenderFns } from "./InTonalBody.vue?vue&type=template&id=40bb82ce&"
import script from "./InTonalBody.vue?vue&type=script&lang=js&"
export * from "./InTonalBody.vue?vue&type=script&lang=js&"
import style0 from "./InTonalBody.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports